<template>
  <main class="main" role="main">
    <div class="main__inner bg">
      <div class="main__con" id="main__con">
        <button type="button" class="page-close" aria-label="닫기" @click="closePage"></button>

        <div v-if="isLoading" class="state">
          <div class="spinner" aria-hidden="true"></div>
          <div class="state__title">보고서를 불러오는 중입니다.</div>
          <div class="state__desc">잠시만 기다려주세요.</div>
        </div>

        <div v-else-if="isEmpty" class="state">
          <div class="state__title">보고서 정보가 없습니다.</div>
          <div class="state__desc">{{ emptyMessage }}</div>
        </div>

        <div v-else-if="isReady">
          <section class="summary summary--brand">
            <div class="summary__brand">{{ brandName }}</div>
          </section>

          <section class="summary summary--company">
            <div class="summary__headline">
              <span class="summary__company">{{ companyName }}</span>
              <span class="summary__suffix">님의</span>
            </div>
            <div class="summary__title">
              <span class="summary__month">{{ reportMonthText }}</span>
              <span class="summary__title__sub">전기절감 납부금액</span>
            </div>
          </section>

          <div class="line"></div>

          <section class="summary summary--kv summary--payment">
            <div class="kv">
              <div class="kv__label">총 납부금액</div>
              <div class="kv__value">{{ $Util.formatNumber(totalPayment) }}원</div>
            </div>
          </section>

          <div class="line_10"></div>

          <section class="summary summary--kv">
            <div class="kv">
              <div class="kv__label">고객번호</div>
              <div class="kv__value">{{ customerNo }}</div>
            </div>
          </section>

          <section class="blue-total">
            <ul class="total-content">
              <li>중부하</li>
              <li class="kwh">{{ $Util.formatNumber(totalHeavyLoadKwh) }}</li>
              <li>컨설팅전</li>
              <li class="won">{{ $Util.formatNumber(beforeConsultingWon) }}</li>

              <li>최대부하</li>
              <li class="kwh">{{ $Util.formatNumber(totalMaxLoadKwh) }}</li>
              <li>컨설팅후</li>
              <li class="won">{{ $Util.formatNumber(afterConsultingWon) }}</li>

              <li>경부하</li>
              <li class="kwh">{{ $Util.formatNumber(totalLightLoadKwh) }}</li>
              <li>절감금액</li>
              <li class="won">{{ $Util.formatNumber(savePriceWon) }}</li>

              <li>합계</li>
              <li class="kwh">{{ $Util.formatNumber(totalSumLoadKwh) }}</li>
              <li>절감율</li>
              <li class="per">{{ saveRatePercent }}</li>
            </ul>
          </section>

          <section class="summary summary--downloads">
            <div class="downloads__title">보고서 다운로드</div>
            <button type="button" class="download-row" @click="download('detail')">
              <span class="download-row__text">해당 월 상세보고서</span>
              <span class="download-row__btn">
                <span class="download-row__icon" aria-hidden="true"></span>
                <span class="download-row__label">download</span>
              </span>
            </button>
            <button type="button" class="download-row" @click="download('summary')">
              <span class="download-row__text">종합 보고서</span>
              <span class="download-row__btn">
                <span class="download-row__icon" aria-hidden="true"></span>
                <span class="download-row__label">download</span>
              </span>
            </button>
          </section>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data: function () {
    return {
      isLoading: false,
      isReady: false,
      isEmpty: false,
      emptyMessage: '링크를 확인해주세요.',
      brandName: 'KS에너지',
      companyName: '',
      customerNo: '—',
      reportYear: 2025,
      reportMonth: 11,
      totalPayment: 0,
      totalHeavyLoadKwh: 0,
      totalMaxLoadKwh: 0,
      totalLightLoadKwh: 0,
      totalSumLoadKwh: 0,
      beforeConsultingWon: 0,
      afterConsultingWon: 0,
      savePriceWon: 0,
      saveRatePercent: '0',
      detailReportUrl: '',
      summaryReportUrl: ''
    }
  },
  computed: {
    reportMonthText: function () {
      return `${this.reportYear}년 ${this.reportMonth}월`
    }
  },
  created: async function () {
    const q = this.$route.query || {}

    if (!this.$Util.isEmpty(q.assetNo)) {
      this.isLoading = true
      await this.fetchMonthlySummary(q.assetNo)
      return
    }

    this.isEmpty = true
    this.emptyMessage = '링크가 올바르지 않습니다.'
  },
  methods: {
    fetchMonthlySummary: async function (assetNo) {
      try {
        const res = await this.$PublicReportSvc.getMonthlySummary({assetNo})
        const code = res.code
        const entity = res.entity

        if (code !== 1 || this.$Util.isEmpty(entity)) {
          this.isEmpty = true
          this.emptyMessage = '잘못된 assetNo 이거나, 보고서 데이터가 없습니다.'
          return
        }

        if (!this.$Util.isEmpty(entity.brandName)) this.brandName = entity.brandName
        if (!this.$Util.isEmpty(entity.companyName)) this.companyName = entity.companyName
        if (!this.$Util.isEmpty(entity.customerNo)) this.customerNo = entity.customerNo

        const year = parseInt(entity.reportYear, 10)
        const month = parseInt(entity.reportMonth, 10)
        if (!Number.isNaN(year)) this.reportYear = year
        if (!Number.isNaN(month)) this.reportMonth = month

        this.totalPayment = this.safeNumber(entity.totalPayment, this.totalPayment)
        this.totalHeavyLoadKwh = this.safeNumber(entity.totalHeavyLoadKwh, this.totalHeavyLoadKwh)
        this.totalMaxLoadKwh = this.safeNumber(entity.totalMaxLoadKwh, this.totalMaxLoadKwh)
        this.totalLightLoadKwh = this.safeNumber(entity.totalLightLoadKwh, this.totalLightLoadKwh)
        this.totalSumLoadKwh = this.safeNumber(entity.totalSumLoadKwh, this.totalSumLoadKwh)
        this.beforeConsultingWon = this.safeNumber(entity.beforeConsultingWon, this.beforeConsultingWon)
        this.afterConsultingWon = this.safeNumber(entity.afterConsultingWon, this.afterConsultingWon)
        this.savePriceWon = this.safeNumber(entity.savePriceWon, this.savePriceWon)
        if (!this.$Util.isEmpty(entity.saveRatePercent)) this.saveRatePercent = entity.saveRatePercent

        if (!this.$Util.isEmpty(entity.detailReportUrl)) this.detailReportUrl = entity.detailReportUrl
        if (!this.$Util.isEmpty(entity.summaryReportUrl)) this.summaryReportUrl = entity.summaryReportUrl

        this.isReady = true
      } catch (e) {
        this.isEmpty = true
        this.emptyMessage = '네트워크 오류로 보고서를 불러오지 못했습니다.'
      } finally {
        this.isLoading = false
      }
    },
    safeNumber: function (value, fallback) {
      const parsed = typeof value === 'number' ? value : parseFloat(value)
      if (Number.isNaN(parsed)) return fallback
      return parsed
    },
    closePage: function () {
      if (window.history && window.history.length > 1) {
        window.history.back()
        return
      }
      window.close()
    },
    download: function (type) {
      const url = type === 'detail' ? this.detailReportUrl : this.summaryReportUrl
      if (this.$Util.isEmpty(url)) {
        this.$Util.modalAlert({message: '다운로드 파일이 없습니다.'})
        return
      }
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.page-close {
  position: fixed;
  top: 1.2rem;
  right: 1.2rem;
  width: 3.6rem;
  height: 3.6rem;
  border: 0;
  background: transparent;
  z-index: 10;
  background-image: url('~src/assets/static/images/i_x.svg');
  background-size: 100%;
  background-repeat: no-repeat;
}

.state {
  min-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  padding: 2.4rem 1.6rem;
  text-align: center;

  &__title {
    font-size: 1.6rem;
    font-weight: 700;
    color: #111;
  }

  &__desc {
    font-size: 1.3rem;
    font-weight: 500;
    color: #616161;
    line-height: 1.6;
  }
}

.spinner {
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  border: 3px solid rgba(0, 0, 0, 0.08);
  border-top-color: rgba(25, 128, 195, 1);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.summary {
  padding: 1.6rem;

  &--brand {
    background-color: #fff;
  }

  &--company {
    background-color: #F5F6FD;
  }

  &__brand {
    text-align: center;
    font-size: 1.8rem;
    font-weight: 700;
    color: #111;
    padding: 0.8rem 0 1.2rem;
  }

  &__headline {
    display: flex;
    justify-content: center;
    align-items: baseline;
    gap: 0.6rem;
    font-size: 1.6rem;
    color: #111;
    padding: 0.2rem 0 0.8rem;
  }

  &__company {
    color: #1980C3;
    font-weight: 700;
  }

  &__suffix {
    color: #616161;
    font-weight: 500;
  }

  &__title {
    display: flex;
    justify-content: center;
    align-items: baseline;
    gap: 1.2rem;
    font-size: 1.8rem;
    font-weight: 700;
    color: #111;
    padding-bottom: 0.4rem;

    &__sub {
      font-size: 1.6rem;
      font-weight: 600;
      color: #111;
    }
  }

  &__month {
    font-weight: 700;
  }

  &--kv {
    padding: 1.2rem 1.6rem;
  }

  &--payment {
    background-color: #F5F6FD;
  }

  &--downloads {
    padding: 2.4rem 1.6rem 3.2rem;
  }
}

.kv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  font-size: 1.6rem;

  &__label {
    font-weight: 600;
    color: #111;
  }

  &__value {
    font-weight: 700;
    color: #111;
    text-align: right;
  }
}

/* /main/report 의 report-total 스타일을 페이지용으로 복제 */
.blue-total {
  padding: 1.5rem 2rem 1.8rem;
  color: #fff;
  background-color: #1980C3;

  & > ul.total-content {
    font-size: 1.25rem;
    line-height: 2.4rem;

    & > li {
      display: inline-block;

      &.kwh:after {
        font-size: 1.2rem;
        font-weight: normal;
        content: 'Kwh'
      }

      &.won:after {
        font-size: 1.2rem;
        font-weight: normal;
        content: '원'
      }

      &.per:after {
        font-size: 1.2rem;
        font-weight: normal;
        content: '%'
      }

      &:nth-child(odd) {
        width: 15%;
        font-weight: 600;
        text-align: center;
      }

      &:nth-child(even) {
        width: calc(35% - 0.5rem);
        font-weight: 700;
        text-align: right;
      }

      &:nth-child(even):not(:nth-child(4n)) {
        margin-right: 1rem;
      }
    }
  }
}

.downloads__title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #111;
  margin-bottom: 1.2rem;
}

.download-row {
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  border: 2px solid #2F3A8F;
  border-radius: 0.6rem;
  overflow: hidden;
  background: #F4F8FF;
  padding: 0;
  margin-bottom: 1.2rem;

  &__text {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    padding: 1.4rem 1.6rem;
    font-size: 1.6rem;
    font-weight: 600;
    color: #111;
    text-align: left;
  }

  &__btn {
    flex: 0 0 7.2rem;
    background: #2F3A8F;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
  }

  &__label {
    font-size: 1.1rem;
    font-weight: 700;
    letter-spacing: 0.01em;
    text-transform: lowercase;
  }

  &__icon {
    width: 1.8rem;
    height: 1.8rem;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      left: 50%;
      top: 2px;
      width: 2px;
      height: 11px;
      background: #fff;
      transform: translateX(-50%);
      border-radius: 1px;
    }

    &:after {
      content: '';
      position: absolute;
      left: 50%;
      top: 9px;
      width: 8px;
      height: 8px;
      border-right: 2px solid #fff;
      border-bottom: 2px solid #fff;
      transform: translateX(-50%) rotate(45deg);
    }
  }
}
</style>
